module.exports = __webpack_public_path__ + "static/media/670MeldrumStNW_2018-06-18_114.ae595a1c.jpg";